import {createApp} from 'vue';
import ElementPlus from 'element-plus';
import 'dayjs/locale/zh-cn'
import ElementPlusLocaleZhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from "./router/router.js";
import store from "./store";
import jquery from 'jquery';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import print from 'vue3-print-nb'
import {startIdleMonitor} from '@/utils/auth'

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

const app = createApp(App)
app.use(store)
app.use(router)
app.use(jquery)
app.use(print)
app.use(ElementPlus, { locale: ElementPlusLocaleZhCn })
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.mount('#app')
startIdleMonitor()
